import { render, staticRenderFns } from "./Offices.vue?vue&type=template&id=0bdc56b2&"
import script from "./Offices.vue?vue&type=script&lang=js&"
export * from "./Offices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports